export const defaultLang = "th";

export const supportedLangs = {
  th: "ภาษาไทย",
  en: "English",
};

export const langUrl = "/lang/{lang}.json";

// Language configuration
export const languageConfig = {
  th: {
    code: "th",
    name: "ภาษาไทย",
    nativeName: "ไทย",
    flag: "🇹🇭",
    direction: "ltr",
    locale: "th-TH",
  },
  en: {
    code: "en",
    name: "English",
    nativeName: "English",
    flag: "🇺🇸",
    direction: "ltr",
    locale: "en-US",
  },
};

// Fallback translations for critical keys
export const fallbackTranslations = {
  "common.loading": "Loading...",
  "common.error": "Error",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.back": "Back",
};
